import React, { useState } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import { useHistory } from "react-router-dom";
import { addVolunteer } from "../../store/actions/volunteers_action";
import AddForm from "../../components/common/AddForm";
import { upload } from "../../shared/upload";
import { initialValues, inputFields } from "../../shared/enums/volunteers_enum";
const AddVolunteer = ({ addVolunteer }) => {
  let history = useHistory();
  const [featuredImage, setFeaturedImage] = useState(null);
  const [gallery, setGallery] = useState(null);

  const submitVolunteer = async (values) => {
    if (featuredImage || gallery) {
      const images = await upload(featuredImage, gallery);
      if (images) {
        if (images.featured_image) {
          values.featured_image = images.featured_image;
        }
        if (images.gallery_images) {
          values.gallery = images.gallery_images;
        }
      }
    }
    await addVolunteer(values);
    history.push("/volunteers");
  };

  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Add Volunteer"
          mainLinkTitle="Volunteers"
          mainLinkUrl="/volunteers"
          activeLink="Add"
        />
      </div>
      <div className="container-fluid">
        <div className="col-lg-9">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Volunteer</h4>
              <p className="card-title-desc">Enter Details to add Volunteer</p>
            </div>
            <AddForm
              edit={false}
              featuredImage={featuredImage}
              gallery={gallery}
              setFeaturedImage={setFeaturedImage}
              setGallery={setGallery}
              submitForm={submitVolunteer}
              inputFields={inputFields}
              initialValues={initialValues}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ alert: state.alert });

const mapDispatchToProps = { addVolunteer };

export default connect(mapStateToProps, mapDispatchToProps)(AddVolunteer);
